import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["price", "down", "rate", "term", "extra",
                    "payment", "totalInterest", "totalCost", "results"]

  connect() { this.calculate() }

  calculate() {
    const price    = parseFloat(this.priceTarget.value.replace(/,/g, "")) || 0
    const down     = parseFloat(this.downTarget.value.replace(/,/g, "")) || 0
    const rate     = parseFloat(this.rateTarget.value) || 0
    const termYrs  = parseInt(this.termTarget.value) || 30
    const extra    = parseFloat(this.extraTarget.value.replace(/,/g, "")) || 0

    if (price <= 0 || rate <= 0) return

    const principal  = price - down
    const monthly    = rate / 100 / 12
    const payments   = termYrs * 12
    const monthlyPmt = principal * (monthly * Math.pow(1 + monthly, payments)) / (Math.pow(1 + monthly, payments) - 1)
    const downPct    = price > 0 ? ((down / price) * 100).toFixed(1) : 0

    // Base stats (no extra)
    const totalInterest = (monthlyPmt * payments) - principal
    this.paymentTarget.textContent      = fmt(monthlyPmt)
    this.totalInterestTarget.textContent = fmt(totalInterest)
    this.totalCostTarget.textContent     = fmt(monthlyPmt * payments + down)
    this.resultsTarget.classList.remove("hidden")
    document.getElementById("down-pct").textContent = `(${downPct}%)`

    // Amortization (with extra payment if provided)
    const totalPmt    = monthlyPmt + extra
    let balance       = principal
    let months        = 0
    let intPaidExtra  = 0
    let annualRows    = ""
    let yr            = 1
    let yrInt = 0, yrPrin = 0

    while (balance > 0.01 && months < payments + 1) {
      const intCharge  = balance * monthly
      const prinCharge = Math.min(totalPmt - intCharge, balance)
      yrInt   += intCharge
      yrPrin  += prinCharge
      balance -= prinCharge
      intPaidExtra += intCharge
      months++

      if (months % 12 === 0 || balance <= 0.01) {
        annualRows += `<tr class="border-b border-gray-100">
          <td class="py-1.5 pr-4 text-sm text-gray-600">Year ${yr}</td>
          <td class="py-1.5 pr-4 text-sm text-gray-800">${fmt(totalPmt)}/mo</td>
          <td class="py-1.5 pr-4 text-sm text-red-700">${fmt(yrInt)}</td>
          <td class="py-1.5 pr-4 text-sm text-green-700">${fmt(yrPrin)}</td>
          <td class="py-1.5 text-sm text-gray-700">${fmt(Math.max(balance, 0))}</td>
        </tr>`
        yrInt = 0; yrPrin = 0; yr++
      }
    }

    document.getElementById("amortization-body").innerHTML = annualRows
    document.getElementById("amortization-table").classList.remove("hidden")

    // Extra payment savings callout
    const savingsEl = document.getElementById("extra-payment-savings")
    if (extra > 0) {
      const interestSaved = totalInterest - intPaidExtra
      const monthsSaved   = payments - months
      const payoffDate    = new Date()
      payoffDate.setMonth(payoffDate.getMonth() + months)
      const dateStr = payoffDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })

      const yrsSaved = Math.floor(monthsSaved / 12)
      const moSaved  = monthsSaved % 12
      const timeSaved = yrsSaved > 0
        ? `${yrsSaved}y ${moSaved}mo`
        : `${moSaved} mo`

      document.getElementById("savings-interest").textContent = fmt(interestSaved)
      document.getElementById("savings-time").textContent     = timeSaved
      document.getElementById("savings-date").textContent     = dateStr
      savingsEl.classList.remove("hidden")
    } else {
      savingsEl.classList.add("hidden")
    }
  }
}

function fmt(n) {
  return "$" + Math.round(n).toLocaleString("en-US")
}
